<template>
	<li class="accordion__item">
		<div
			class="accordion__trigger"
			:class="{ accordion__trigger_active: visible }"
			@click="open"
		>
			<!-- This slot will handle the title/header of the accordion and is the part you click on -->
			<slot name="accordion-trigger"></slot>

			<div class="toggle">
				<h5 class="coverage-show" v-if="!visible && window.width >= 1240">
					Show Details
				</h5>
				<h5 class="coverage-show" v-if="!visible && window.width < 1240">
					Details
				</h5>

				<h5 class="coverage-hide" v-if="visible && window.width >= 1240">
					Hide
				</h5>
				<h5 class="coverage-hide" v-if="visible && window.width < 1240">
					Details
				</h5>

				<div class="toggle-icon plus" v-if="!visible">
					<svg
						width="24px"
						height="24px"
						viewBox="0 0 24 24"
						xmlns="http://www.w3.org/2000/svg"
					>
						<rect x="0" fill="none" width="24" height="24" />
						<g>
							<path d="M21 13h-8v8h-2v-8H3v-2h8V3h2v8h8v2z" />
						</g>
					</svg>
				</div>

				<div class="toggle-icon minus" v-else>
					<svg
						width="24px"
						height="24px"
						viewBox="0 0 24 24"
						xmlns="http://www.w3.org/2000/svg"
					>
						<rect x="0" fill="none" width="24" height="24" />
						<g>
							<path d="M3 11h18v2H3z" />
						</g>
					</svg>
				</div>
			</div>
		</div>

		<transition
			name="accordion"
			@enter="start"
			@after-enter="end"
			@before-leave="start"
			@after-leave="end"
		>
			<div
				class="accordion__content"
				:class="{ open: visible }"
				v-show="visible"
			>
				<!-- This slot will handle all the content that is passed to the accordion -->
				<slot name="accordion-content"></slot>
			</div>
		</transition>
	</li>
</template>


<script>
export default {
	data() {
		return {
			visible: false,
			window: {
				width: 0,
				height: 0,
			},
		};
	},
	methods: {
		open() {
			this.visible = !this.visible;
		},
		start(el) {
			el.style.height = el.scrollHeight + 'px';
		},
		end(el) {
			el.style.height = '';
		},
		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},
	},

	created() {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('scroll', this.didScroll);
		this.handleResize();
	},

	destroyed() {
		window.removeEventListener('scroll', this.didScroll);
	},

	mounted() {
		this.handleResize();
	},

	updated() {
		this.handleResize();
	},
};
</script>


<style lang="scss" scoped>
@import '../../styles/common/variables';

.accordion {
	&__item {
		position: relative;
		border-radius: 0;
		border-top: 1px solid var(--white);

		&:last-of-type {
			/* border-bottom: var(--border); */

			/* .theme--dark_blue &,
			.theme--white & {
				border-bottom: 1px solid var(--cobalt);
			} */
		}
	}

	&__trigger {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 16px 24px 16px;
		gap: 20px;
		transition: 0.2s ease all;
		color: var(--fpe-blue);
		text-indent: 0;

		&:hover {
			background: var(--fpe-mid-grey);
		}

		/* .accordion__item:last-of-type & {
			padding: 16px 0 0;
		} */
		.toggle {
			display: flex;

			.coverage-show,
			.coverage-hide {
				display: none;
				margin: 0;
			}
		}

		&:hover {
			cursor: pointer;
			background: var(--fpe-mid-grey);

			h3 {
				text-decoration: underline;
			}
		}

		h4 {
			margin: 0;
		}

		h5 {
			margin: 0;
			/* text-transform: capitalize; */
		}

		// &:hover {
		// 	background: var(--stone);
		// 	transition: 0.2s ease all;
		// }
		/* 
		&_active {
			background: var(--stone);
		} */

		p {
			// text-transform: uppercase;
			max-width: calc(100% - 40px);
			margin: 0;
			color: var(--fpe-blue);
			text-transform: unset;
		}

		.toggle-icon {
			display: flex;
			justify-content: center;
			align-items: center;
			border-radius: 50%;
			width: 40px;
			height: 40px;
			background: var(--fpe-blue);
			border: 1px solid var(--fpe-blue);

			svg {
				path {
					fill: var(--white);
				}
			}

			&.minus {
				background: transparent;
				border: 1px solid var(--white);
			}
		}
	}

	&__content {
		padding: 0 0 0;
		color: var(--fpe-blue);

		&::v-deep {
			a {
				font: normal normal 300 17px/25px var(--primary-font-family) !important;

				&.cta {
					display: inline;
				}
			}

			> p,
			div p {
				margin: 0;
				padding: 0 16px 16px 24px;
				color: var(--fpe-blue);
				font: normal normal 300 17px/25px var(--primary-font-family) !important;
				text-indent: 0;

				&:last-of-type {
					margin-bottom: 0;
					font: normal normal 300 17px/25px var(--primary-font-family) !important;
				}

				strong {
					font: normal normal bold 17px/25px var(--primary-font-family) !important;
				}

				.theme--blue &,
				.theme--dark_blue & {
					color: var(--white);
				}
			}

			> p a {
				color: var(--fpe-blue);
				/* font: normal normal 300 14px/25px var(--primary-font-family) !important; */
				font-size: inherit;
				color: var(--fpe-blue);
				text-decoration: none;
				background: linear-gradient(
					180deg,
					rgba(255, 255, 255, 0) 50%,
					#fff3cd 50%
				);
				text-indent: 0;
				position: relative;

				&[href^='mailto:'] {
					padding-left: 42px;

					&::before {
						content: '';
						width: 24px;
						height: 18px;
						border-radius: none;
						background: none;
						display: block;
						-webkit-mask-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAyMyAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wLjA2Njg5NDUgMy4xODczN0MwLjA2Njg5NDUgMS41MzUwOSAxLjQxNDYxIDAuMTg3MzcgMy4wNjY4OSAwLjE4NzM3SDE5LjA2NjlDMjAuNzE5MiAwLjE4NzM3IDIyLjA2NjkgMS41MzUwOSAyMi4wNjY5IDMuMTg3MzdWMTUuMTg3NEMyMi4wNjY5IDE2LjgzOTcgMjAuNzE5MiAxOC4xODc0IDE5LjA2NjkgMTguMTg3NEgzLjA2Njg5QzEuNDE0NjEgMTguMTg3NCAwLjA2Njg5NDUgMTYuODM5NyAwLjA2Njg5NDUgMTUuMTg3NFYzLjE4NzM3Wk0yLjE3MzQ3IDIuNzQxMzJMMTEuMDY2OSA4Ljk2NjcxTDE5Ljk2MDMgMi43NDEzMkMxOS43OTQ5IDIuNDE0MjkgMTkuNDU0OSAyLjE4NzM3IDE5LjA2NjkgMi4xODczN0gzLjA2Njg5QzIuNjc4OTMgMi4xODczNyAyLjMzODg1IDIuNDE0MjkgMi4xNzM0NyAyLjc0MTMyWk0yMC4wNjY5IDUuMTA4MDNMMTEuNjQwNCAxMS4wMDY2QzExLjI5NiAxMS4yNDc2IDEwLjgzNzggMTEuMjQ3NiAxMC40OTM0IDExLjAwNjZMMi4wNjY4OSA1LjEwODAzVjE1LjE4NzRDMi4wNjY4OSAxNS43MzUxIDIuNTE5MTggMTYuMTg3NCAzLjA2Njg5IDE2LjE4NzRIMTkuMDY2OUMxOS42MTQ2IDE2LjE4NzQgMjAuMDY2OSAxNS43MzUxIDIwLjA2NjkgMTUuMTg3NFY1LjEwODAzWiIgZmlsbD0iIzRGNThGNSIvPgo8L3N2Zz4K');
						mask-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAyMyAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wLjA2Njg5NDUgMy4xODczN0MwLjA2Njg5NDUgMS41MzUwOSAxLjQxNDYxIDAuMTg3MzcgMy4wNjY4OSAwLjE4NzM3SDE5LjA2NjlDMjAuNzE5MiAwLjE4NzM3IDIyLjA2NjkgMS41MzUwOSAyMi4wNjY5IDMuMTg3MzdWMTUuMTg3NEMyMi4wNjY5IDE2LjgzOTcgMjAuNzE5MiAxOC4xODc0IDE5LjA2NjkgMTguMTg3NEgzLjA2Njg5QzEuNDE0NjEgMTguMTg3NCAwLjA2Njg5NDUgMTYuODM5NyAwLjA2Njg5NDUgMTUuMTg3NFYzLjE4NzM3Wk0yLjE3MzQ3IDIuNzQxMzJMMTEuMDY2OSA4Ljk2NjcxTDE5Ljk2MDMgMi43NDEzMkMxOS43OTQ5IDIuNDE0MjkgMTkuNDU0OSAyLjE4NzM3IDE5LjA2NjkgMi4xODczN0gzLjA2Njg5QzIuNjc4OTMgMi4xODczNyAyLjMzODg1IDIuNDE0MjkgMi4xNzM0NyAyLjc0MTMyWk0yMC4wNjY5IDUuMTA4MDNMMTEuNjQwNCAxMS4wMDY2QzExLjI5NiAxMS4yNDc2IDEwLjgzNzggMTEuMjQ3NiAxMC40OTM0IDExLjAwNjZMMi4wNjY4OSA1LjEwODAzVjE1LjE4NzRDMi4wNjY4OSAxNS43MzUxIDIuNTE5MTggMTYuMTg3NCAzLjA2Njg5IDE2LjE4NzRIMTkuMDY2OUMxOS42MTQ2IDE2LjE4NzQgMjAuMDY2OSAxNS43MzUxIDIwLjA2NjkgMTUuMTg3NFY1LjEwODAzWiIgZmlsbD0iIzRGNThGNSIvPgo8L3N2Zz4K');
						background-color: var(--fpe-blue);
						background-repeat: no-repeat;
						mask-repeat: no-repeat;
						background-position: center center;
						mask-position: center center;
						position: absolute;
						mask-size: 15px;
						left: 0;
						top: 0;
						margin-right: 0;
					}
				}

				&[href^='tel:'] {
					padding-left: 42px;

					&::before {
						content: '';
						width: 24px;
						height: 24px;
						border-radius: none;
						background: none;
						display: block;
						-webkit-mask-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxLjAwMDIgMTUuOTIwMVYxOC45MjAxQzIxLjAwMTMgMTkuMTk4NiAyMC45NDQyIDE5LjQ3NDMgMjAuODMyNyAxOS43Mjk0QzIwLjcyMTEgMTkuOTg0NiAyMC41NTc1IDIwLjIxMzcgMjAuMzUyMiAyMC40MDJDMjAuMTQ3IDIwLjU5MDIgMTkuOTA0NyAyMC43MzM2IDE5LjY0MDkgMjAuODIyOEMxOS4zNzcxIDIwLjkxMiAxOS4wOTc1IDIwLjk0NTIgMTguODIwMiAyMC45MjAxQzE1Ljc0MyAyMC41ODU3IDEyLjc4NzIgMTkuNTM0MiAxMC4xOTAyIDE3Ljg1MDFDNy43NzQgMTYuMzE0OCA1LjcyNTUxIDE0LjI2NjMgNC4xOTAxOCAxMS44NTAxQzIuNTAwMTUgOS4yNDEzIDEuNDQ4NDIgNi4yNzEwOSAxLjEyMDE4IDMuMTgwMUMxLjA5NTE5IDIuOTAzNTYgMS4xMjgwNSAyLjYyNDg2IDEuMjE2NjggMi4zNjE3MkMxLjMwNTMgMi4wOTg1OSAxLjQ0Nzc1IDEuODU2NzkgMS42MzQ5NCAxLjY1MTcyQzEuODIyMTQgMS40NDY2NSAyLjA0OTk4IDEuMjgyODEgMi4zMDM5NyAxLjE3MDYyQzIuNTU3OTUgMS4wNTg0MyAyLjgzMjUyIDEuMDAwMzYgMy4xMTAxOCAxLjAwMDFINi4xMTAxOEM2LjU5NTQ4IDAuOTk1MzIxIDcuMDY1OTcgMS4xNjcxOCA3LjQzMzk0IDEuNDgzNjNDNy44MDE5MSAxLjgwMDA4IDguMDQyMjUgMi4yMzk1NCA4LjExMDE3IDIuNzIwMUM4LjIzNjggMy42ODAxNiA4LjQ3MTYzIDQuNjIyODIgOC44MTAxOCA1LjUzMDFDOC45NDQ3MiA1Ljg4ODAyIDguOTczODQgNi4yNzcwMSA4Ljg5NDA4IDYuNjUwOThDOC44MTQzMyA3LjAyNDk0IDguNjI5MDQgNy4zNjgyMSA4LjM2MDE3IDcuNjQwMUw3LjA5MDE4IDguOTEwMUM4LjUxMzczIDExLjQxMzYgMTAuNTg2NiAxMy40ODY1IDEzLjA5MDIgMTQuOTEwMUwxNC4zNjAyIDEzLjY0MDFDMTQuNjMyIDEzLjM3MTIgMTQuOTc1MyAxMy4xODU5IDE1LjM0OTMgMTMuMTA2MkMxNS43MjMyIDEzLjAyNjQgMTYuMTEyMiAxMy4wNTU2IDE2LjQ3MDIgMTMuMTkwMUMxNy4zNzc0IDEzLjUyODYgMTguMzIwMSAxMy43NjM1IDE5LjI4MDIgMTMuODkwMUMxOS43NjU5IDEzLjk1ODYgMjAuMjA5NiAxNC4yMDMzIDIwLjUyNjcgMTQuNTc3NkMyMC44NDM4IDE0Ljk1MTkgMjEuMDEyMyAxNS40Mjk3IDIxLjAwMDIgMTUuOTIwMVoiIHN0cm9rZT0iIzRGNThGNSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
						mask-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxLjAwMDIgMTUuOTIwMVYxOC45MjAxQzIxLjAwMTMgMTkuMTk4NiAyMC45NDQyIDE5LjQ3NDMgMjAuODMyNyAxOS43Mjk0QzIwLjcyMTEgMTkuOTg0NiAyMC41NTc1IDIwLjIxMzcgMjAuMzUyMiAyMC40MDJDMjAuMTQ3IDIwLjU5MDIgMTkuOTA0NyAyMC43MzM2IDE5LjY0MDkgMjAuODIyOEMxOS4zNzcxIDIwLjkxMiAxOS4wOTc1IDIwLjk0NTIgMTguODIwMiAyMC45MjAxQzE1Ljc0MyAyMC41ODU3IDEyLjc4NzIgMTkuNTM0MiAxMC4xOTAyIDE3Ljg1MDFDNy43NzQgMTYuMzE0OCA1LjcyNTUxIDE0LjI2NjMgNC4xOTAxOCAxMS44NTAxQzIuNTAwMTUgOS4yNDEzIDEuNDQ4NDIgNi4yNzEwOSAxLjEyMDE4IDMuMTgwMUMxLjA5NTE5IDIuOTAzNTYgMS4xMjgwNSAyLjYyNDg2IDEuMjE2NjggMi4zNjE3MkMxLjMwNTMgMi4wOTg1OSAxLjQ0Nzc1IDEuODU2NzkgMS42MzQ5NCAxLjY1MTcyQzEuODIyMTQgMS40NDY2NSAyLjA0OTk4IDEuMjgyODEgMi4zMDM5NyAxLjE3MDYyQzIuNTU3OTUgMS4wNTg0MyAyLjgzMjUyIDEuMDAwMzYgMy4xMTAxOCAxLjAwMDFINi4xMTAxOEM2LjU5NTQ4IDAuOTk1MzIxIDcuMDY1OTcgMS4xNjcxOCA3LjQzMzk0IDEuNDgzNjNDNy44MDE5MSAxLjgwMDA4IDguMDQyMjUgMi4yMzk1NCA4LjExMDE3IDIuNzIwMUM4LjIzNjggMy42ODAxNiA4LjQ3MTYzIDQuNjIyODIgOC44MTAxOCA1LjUzMDFDOC45NDQ3MiA1Ljg4ODAyIDguOTczODQgNi4yNzcwMSA4Ljg5NDA4IDYuNjUwOThDOC44MTQzMyA3LjAyNDk0IDguNjI5MDQgNy4zNjgyMSA4LjM2MDE3IDcuNjQwMUw3LjA5MDE4IDguOTEwMUM4LjUxMzczIDExLjQxMzYgMTAuNTg2NiAxMy40ODY1IDEzLjA5MDIgMTQuOTEwMUwxNC4zNjAyIDEzLjY0MDFDMTQuNjMyIDEzLjM3MTIgMTQuOTc1MyAxMy4xODU5IDE1LjM0OTMgMTMuMTA2MkMxNS43MjMyIDEzLjAyNjQgMTYuMTEyMiAxMy4wNTU2IDE2LjQ3MDIgMTMuMTkwMUMxNy4zNzc0IDEzLjUyODYgMTguMzIwMSAxMy43NjM1IDE5LjI4MDIgMTMuODkwMUMxOS43NjU5IDEzLjk1ODYgMjAuMjA5NiAxNC4yMDMzIDIwLjUyNjcgMTQuNTc3NkMyMC44NDM4IDE0Ljk1MTkgMjEuMDEyMyAxNS40Mjk3IDIxLjAwMDIgMTUuOTIwMVoiIHN0cm9rZT0iIzRGNThGNSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
						background-color: var(--fpe-blue);
						background-repeat: no-repeat;
						mask-repeat: no-repeat;
						background-position: center center;
						mask-position: center center;
						position: absolute;
						mask-size: 15px;
						left: 0;
						top: 0;
						margin-right: 0;
					}
				}

				.theme--blue &,
				.theme--dark_blue & {
					color: var(--white);

					&[href^='mailto:'] {
						padding-left: 42px;

						&::before {
							content: '';
							width: 24px;
							height: 18px;
							border-radius: none;
							background: none;
							display: block;
							-webkit-mask-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAyMyAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wLjA2Njg5NDUgMy4xODczN0MwLjA2Njg5NDUgMS41MzUwOSAxLjQxNDYxIDAuMTg3MzcgMy4wNjY4OSAwLjE4NzM3SDE5LjA2NjlDMjAuNzE5MiAwLjE4NzM3IDIyLjA2NjkgMS41MzUwOSAyMi4wNjY5IDMuMTg3MzdWMTUuMTg3NEMyMi4wNjY5IDE2LjgzOTcgMjAuNzE5MiAxOC4xODc0IDE5LjA2NjkgMTguMTg3NEgzLjA2Njg5QzEuNDE0NjEgMTguMTg3NCAwLjA2Njg5NDUgMTYuODM5NyAwLjA2Njg5NDUgMTUuMTg3NFYzLjE4NzM3Wk0yLjE3MzQ3IDIuNzQxMzJMMTEuMDY2OSA4Ljk2NjcxTDE5Ljk2MDMgMi43NDEzMkMxOS43OTQ5IDIuNDE0MjkgMTkuNDU0OSAyLjE4NzM3IDE5LjA2NjkgMi4xODczN0gzLjA2Njg5QzIuNjc4OTMgMi4xODczNyAyLjMzODg1IDIuNDE0MjkgMi4xNzM0NyAyLjc0MTMyWk0yMC4wNjY5IDUuMTA4MDNMMTEuNjQwNCAxMS4wMDY2QzExLjI5NiAxMS4yNDc2IDEwLjgzNzggMTEuMjQ3NiAxMC40OTM0IDExLjAwNjZMMi4wNjY4OSA1LjEwODAzVjE1LjE4NzRDMi4wNjY4OSAxNS43MzUxIDIuNTE5MTggMTYuMTg3NCAzLjA2Njg5IDE2LjE4NzRIMTkuMDY2OUMxOS42MTQ2IDE2LjE4NzQgMjAuMDY2OSAxNS43MzUxIDIwLjA2NjkgMTUuMTg3NFY1LjEwODAzWiIgZmlsbD0iIzRGNThGNSIvPgo8L3N2Zz4K');
							mask-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAyMyAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wLjA2Njg5NDUgMy4xODczN0MwLjA2Njg5NDUgMS41MzUwOSAxLjQxNDYxIDAuMTg3MzcgMy4wNjY4OSAwLjE4NzM3SDE5LjA2NjlDMjAuNzE5MiAwLjE4NzM3IDIyLjA2NjkgMS41MzUwOSAyMi4wNjY5IDMuMTg3MzdWMTUuMTg3NEMyMi4wNjY5IDE2LjgzOTcgMjAuNzE5MiAxOC4xODc0IDE5LjA2NjkgMTguMTg3NEgzLjA2Njg5QzEuNDE0NjEgMTguMTg3NCAwLjA2Njg5NDUgMTYuODM5NyAwLjA2Njg5NDUgMTUuMTg3NFYzLjE4NzM3Wk0yLjE3MzQ3IDIuNzQxMzJMMTEuMDY2OSA4Ljk2NjcxTDE5Ljk2MDMgMi43NDEzMkMxOS43OTQ5IDIuNDE0MjkgMTkuNDU0OSAyLjE4NzM3IDE5LjA2NjkgMi4xODczN0gzLjA2Njg5QzIuNjc4OTMgMi4xODczNyAyLjMzODg1IDIuNDE0MjkgMi4xNzM0NyAyLjc0MTMyWk0yMC4wNjY5IDUuMTA4MDNMMTEuNjQwNCAxMS4wMDY2QzExLjI5NiAxMS4yNDc2IDEwLjgzNzggMTEuMjQ3NiAxMC40OTM0IDExLjAwNjZMMi4wNjY4OSA1LjEwODAzVjE1LjE4NzRDMi4wNjY4OSAxNS43MzUxIDIuNTE5MTggMTYuMTg3NCAzLjA2Njg5IDE2LjE4NzRIMTkuMDY2OUMxOS42MTQ2IDE2LjE4NzQgMjAuMDY2OSAxNS43MzUxIDIwLjA2NjkgMTUuMTg3NFY1LjEwODAzWiIgZmlsbD0iIzRGNThGNSIvPgo8L3N2Zz4K');
							background-color: var(--white);
							background-repeat: no-repeat;
							mask-repeat: no-repeat;
							background-position: center center;
							mask-position: center center;
							position: absolute;
							mask-size: 15px;
							left: 0;
							top: 0;
							margin-right: 0;
						}
					}

					&[href^='tel:'] {
						padding-left: 42px;

						&::before {
							content: '';
							width: 24px;
							height: 24px;
							border-radius: none;
							background: none;
							display: block;
							-webkit-mask-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxLjAwMDIgMTUuOTIwMVYxOC45MjAxQzIxLjAwMTMgMTkuMTk4NiAyMC45NDQyIDE5LjQ3NDMgMjAuODMyNyAxOS43Mjk0QzIwLjcyMTEgMTkuOTg0NiAyMC41NTc1IDIwLjIxMzcgMjAuMzUyMiAyMC40MDJDMjAuMTQ3IDIwLjU5MDIgMTkuOTA0NyAyMC43MzM2IDE5LjY0MDkgMjAuODIyOEMxOS4zNzcxIDIwLjkxMiAxOS4wOTc1IDIwLjk0NTIgMTguODIwMiAyMC45MjAxQzE1Ljc0MyAyMC41ODU3IDEyLjc4NzIgMTkuNTM0MiAxMC4xOTAyIDE3Ljg1MDFDNy43NzQgMTYuMzE0OCA1LjcyNTUxIDE0LjI2NjMgNC4xOTAxOCAxMS44NTAxQzIuNTAwMTUgOS4yNDEzIDEuNDQ4NDIgNi4yNzEwOSAxLjEyMDE4IDMuMTgwMUMxLjA5NTE5IDIuOTAzNTYgMS4xMjgwNSAyLjYyNDg2IDEuMjE2NjggMi4zNjE3MkMxLjMwNTMgMi4wOTg1OSAxLjQ0Nzc1IDEuODU2NzkgMS42MzQ5NCAxLjY1MTcyQzEuODIyMTQgMS40NDY2NSAyLjA0OTk4IDEuMjgyODEgMi4zMDM5NyAxLjE3MDYyQzIuNTU3OTUgMS4wNTg0MyAyLjgzMjUyIDEuMDAwMzYgMy4xMTAxOCAxLjAwMDFINi4xMTAxOEM2LjU5NTQ4IDAuOTk1MzIxIDcuMDY1OTcgMS4xNjcxOCA3LjQzMzk0IDEuNDgzNjNDNy44MDE5MSAxLjgwMDA4IDguMDQyMjUgMi4yMzk1NCA4LjExMDE3IDIuNzIwMUM4LjIzNjggMy42ODAxNiA4LjQ3MTYzIDQuNjIyODIgOC44MTAxOCA1LjUzMDFDOC45NDQ3MiA1Ljg4ODAyIDguOTczODQgNi4yNzcwMSA4Ljg5NDA4IDYuNjUwOThDOC44MTQzMyA3LjAyNDk0IDguNjI5MDQgNy4zNjgyMSA4LjM2MDE3IDcuNjQwMUw3LjA5MDE4IDguOTEwMUM4LjUxMzczIDExLjQxMzYgMTAuNTg2NiAxMy40ODY1IDEzLjA5MDIgMTQuOTEwMUwxNC4zNjAyIDEzLjY0MDFDMTQuNjMyIDEzLjM3MTIgMTQuOTc1MyAxMy4xODU5IDE1LjM0OTMgMTMuMTA2MkMxNS43MjMyIDEzLjAyNjQgMTYuMTEyMiAxMy4wNTU2IDE2LjQ3MDIgMTMuMTkwMUMxNy4zNzc0IDEzLjUyODYgMTguMzIwMSAxMy43NjM1IDE5LjI4MDIgMTMuODkwMUMxOS43NjU5IDEzLjk1ODYgMjAuMjA5NiAxNC4yMDMzIDIwLjUyNjcgMTQuNTc3NkMyMC44NDM4IDE0Ljk1MTkgMjEuMDEyMyAxNS40Mjk3IDIxLjAwMDIgMTUuOTIwMVoiIHN0cm9rZT0iIzRGNThGNSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
							mask-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxLjAwMDIgMTUuOTIwMVYxOC45MjAxQzIxLjAwMTMgMTkuMTk4NiAyMC45NDQyIDE5LjQ3NDMgMjAuODMyNyAxOS43Mjk0QzIwLjcyMTEgMTkuOTg0NiAyMC41NTc1IDIwLjIxMzcgMjAuMzUyMiAyMC40MDJDMjAuMTQ3IDIwLjU5MDIgMTkuOTA0NyAyMC43MzM2IDE5LjY0MDkgMjAuODIyOEMxOS4zNzcxIDIwLjkxMiAxOS4wOTc1IDIwLjk0NTIgMTguODIwMiAyMC45MjAxQzE1Ljc0MyAyMC41ODU3IDEyLjc4NzIgMTkuNTM0MiAxMC4xOTAyIDE3Ljg1MDFDNy43NzQgMTYuMzE0OCA1LjcyNTUxIDE0LjI2NjMgNC4xOTAxOCAxMS44NTAxQzIuNTAwMTUgOS4yNDEzIDEuNDQ4NDIgNi4yNzEwOSAxLjEyMDE4IDMuMTgwMUMxLjA5NTE5IDIuOTAzNTYgMS4xMjgwNSAyLjYyNDg2IDEuMjE2NjggMi4zNjE3MkMxLjMwNTMgMi4wOTg1OSAxLjQ0Nzc1IDEuODU2NzkgMS42MzQ5NCAxLjY1MTcyQzEuODIyMTQgMS40NDY2NSAyLjA0OTk4IDEuMjgyODEgMi4zMDM5NyAxLjE3MDYyQzIuNTU3OTUgMS4wNTg0MyAyLjgzMjUyIDEuMDAwMzYgMy4xMTAxOCAxLjAwMDFINi4xMTAxOEM2LjU5NTQ4IDAuOTk1MzIxIDcuMDY1OTcgMS4xNjcxOCA3LjQzMzk0IDEuNDgzNjNDNy44MDE5MSAxLjgwMDA4IDguMDQyMjUgMi4yMzk1NCA4LjExMDE3IDIuNzIwMUM4LjIzNjggMy42ODAxNiA4LjQ3MTYzIDQuNjIyODIgOC44MTAxOCA1LjUzMDFDOC45NDQ3MiA1Ljg4ODAyIDguOTczODQgNi4yNzcwMSA4Ljg5NDA4IDYuNjUwOThDOC44MTQzMyA3LjAyNDk0IDguNjI5MDQgNy4zNjgyMSA4LjM2MDE3IDcuNjQwMUw3LjA5MDE4IDguOTEwMUM4LjUxMzczIDExLjQxMzYgMTAuNTg2NiAxMy40ODY1IDEzLjA5MDIgMTQuOTEwMUwxNC4zNjAyIDEzLjY0MDFDMTQuNjMyIDEzLjM3MTIgMTQuOTc1MyAxMy4xODU5IDE1LjM0OTMgMTMuMTA2MkMxNS43MjMyIDEzLjAyNjQgMTYuMTEyMiAxMy4wNTU2IDE2LjQ3MDIgMTMuMTkwMUMxNy4zNzc0IDEzLjUyODYgMTguMzIwMSAxMy43NjM1IDE5LjI4MDIgMTMuODkwMUMxOS43NjU5IDEzLjk1ODYgMjAuMjA5NiAxNC4yMDMzIDIwLjUyNjcgMTQuNTc3NkMyMC44NDM4IDE0Ljk1MTkgMjEuMDEyMyAxNS40Mjk3IDIxLjAwMDIgMTUuOTIwMVoiIHN0cm9rZT0iIzRGNThGNSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
							background-color: var(--white);
							background-repeat: no-repeat;
							mask-repeat: no-repeat;
							background-position: center center;
							mask-position: center center;
							position: absolute;
							mask-size: 15px;
							left: 0;
							top: 0;
							margin-right: 0;
						}
					}
				}

				strong {
					font: normal normal bold 17px/25px var(--primary-font-family) !important;
				}
			}

			p {
				color: var(--fpe-blue);
				font: normal normal 300 17px/25px var(--primary-font-family) !important;
				text-indent: 0;

				.theme--blue &,
				.theme--dark_blue & {
					color: var(--white);
				}

				strong {
					font: normal normal bold 17px/25px var(--primary-font-family) !important;
				}
			}

			ul {
				display: flex;
				flex-direction: column;
				margin: 0 0 20px 20px;
				padding: 0 20px 0 18px;
				gap: 10px;

				li {
					color: var(--fpe-blue);
					font: normal normal 300 17px/25px var(--primary-font-family) !important;
					list-style-type: disc;

					.theme--blue &,
					.theme--dark_blue & {
						color: var(--white);
					}

					strong {
						font: normal normal bold 17px/25px var(--primary-font-family) !important;
					}

					a {
						color: var(--fpe-blue);
						font: normal normal 300 17px/25px var(--primary-font-family) !important;
						text-indent: 0;
						padding: 0;

						.theme--blue &,
						.theme--dark_blue & {
							color: var(--white);
						}

						strong {
							font: normal normal bold 17px/25px var(--primary-font-family) !important;
						}
					}
				}
			}

			ol {
				display: flex;
				flex-direction: column;
				margin: 0 0 20px 20px;
				padding: 0 20px 0 18px;
				gap: 10px;
				list-style: auto;

				li {
					color: var(--fpe-blue);
					font: normal normal 300 17px/25px var(--primary-font-family) !important;
					list-style-type: disc;

					.theme--blue &,
					.theme--dark_blue & {
						color: var(--white);
					}

					strong {
						font: normal normal bold 17px/25px var(--primary-font-family) !important;
					}

					a {
						color: var(--fpe-blue);
						font: normal normal 300 17px/25px var(--primary-font-family) !important;
						text-indent: 0;
						padding: 0;

						.theme--blue &,
						.theme--dark_blue & {
							color: var(--white);
						}

						strong {
							font: normal normal bold 17px/25px var(--primary-font-family) !important;
						}
					}
				}
			}

			.site_button {
				margin-top: 16px;
				margin-left: 0;
			}

			hr {
				margin: 0 16px 16px;
				width: calc(100% - 32px);
			}
		}

		&::v-deep {
			.site_button_secondary {
				margin-bottom: 16px;
				margin-left: 0;

				.theme--blue & {
					border: 1px solid var(--white);
					color: var(--white);

					span {
						color: var(--white);
					}

					svg {
						path {
							stroke: var(--white);
						}
					}

					&:hover {
						background: var(--white);
						border: 1px solid var(--white);
						color: var(--fpe-blue);

						span {
							color: var(--fpe-blue);
						}

						svg {
							path {
								stroke: var(--cobalt);
							}
						}
					}
				}

				.theme--dark_blue & {
					border: 1px solid var(--white);
					color: var(--white);

					span {
						color: var(--white);
					}

					svg {
						path {
							stroke: var(--white);
						}
					}

					&:hover {
						border: 1px solid var(--white);
						background: var(--white);
						color: var(--fpe-blue);

						span {
							color: var(--fpe-blue);
						}

						svg {
							path {
								stroke: var(--cobalt);
							}
						}
					}
				}

				.theme--white &,
				.theme--none & {
					border: 1px solid var(--fpe-blue);
					color: var(--fpe-blue);

					span {
						color: var(--fpe-blue);
					}

					svg {
						path {
							stroke: var(--cobalt);
						}
					}

					&:hover {
						border: 1px solid var(--fpe-blue);
						background: var(--fpe-blue);
						color: var(--white);

						span {
							color: var(--white);
						}

						svg {
							path {
								stroke: var(--cobalt);
							}
						}
					}
				}
			}
		}

		&::v-deep {
			.benefit_sub_question__accordion-trigger {
				h5 {
					margin: 0 0 8px;
				}
			}
		}
	}

	&::v-deep {
		.tier_one {
			margin-bottom: 40px;
		}
	}
}

.accordion-enter-active,
.accordion-leave-active {
	will-change: height, opacity, padding-bottom;
	transition: height 0.3s ease, opacity 0.3s ease, padding-bottom 0.3s ease;
	overflow: hidden;
}

.accordion-enter,
.accordion-leave-to {
	height: 0 !important;
	opacity: 0;
	padding-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/AccordionItem.vue